import { runbookStepConstants } from "../constants/runbookStep.constants";

export function runbookStep(state = {}, action) {
  switch (action.type) {
    case runbookStepConstants.GET_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
      };
    case runbookStepConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
      };
    case runbookStepConstants.GET_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case runbookStepConstants.GET_ALL_ACTIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case runbookStepConstants.GET_ALL_ACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        actions: action.payload,
      };
    case runbookStepConstants.GET_ALL_ACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case runbookStepConstants.ADD_BLANK_REQUEST:
    case runbookStepConstants.ADD_FORLOOPENDLOOP_REQUEST:
    case runbookStepConstants.ADD_AFTER_REQUEST:
    case runbookStepConstants.ADD_BEFORE_REQUEST:
    case runbookStepConstants.ADD_TRUE_REQUEST:
    case runbookStepConstants.ADD_FALSE_REQUEST:
    case runbookStepConstants.DELETE_REQUEST:
    case runbookStepConstants.UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        errorMessage: "",
      };
    case runbookStepConstants.ADD_BLANK_SUCCESS:
    case runbookStepConstants.ADD_FORLOOPENDLOOP_SUCCESS:
    case runbookStepConstants.ADD_AFTER_SUCCESS:
    case runbookStepConstants.ADD_BEFORE_SUCCESS:
    case runbookStepConstants.ADD_TRUE_SUCCESS:
    case runbookStepConstants.ADD_FALSE_SUCCESS:
    case runbookStepConstants.DELETE_SUCCESS:
    case runbookStepConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case runbookStepConstants.ADD_BLANK_FAILURE:
    case runbookStepConstants.ADD_FORLOOPENDLOOP_FAILURE:
    case runbookStepConstants.ADD_AFTER_FAILURE:
    case runbookStepConstants.ADD_BEFORE_FAILURE:
    case runbookStepConstants.ADD_TRUE_FAILURE:
    case runbookStepConstants.ADD_FALSE_FAILURE:
    case runbookStepConstants.DELETE_FAILURE:
    case runbookStepConstants.UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: action.message,
      };
    default:
      return state;
  }
}
